(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-header';

  function initHeader(header) {
    if (!header || header.__odditHeaderInit) return;
    header.__odditHeaderInit = true;

    var megaMenu = header.querySelector('[data-mega-menu-panel]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var megaInners = header.querySelectorAll('.oddit-header__mega-menu-inner');
    var overlay = header.querySelector('.oddit-header__overlay');
    var mobileMenu = header.querySelector('[data-mobile-menu-panel]');
    var mobileOpenBtn = header.querySelector('[data-mobile-menu-open]');
    var mobileCloseBtns = header.querySelectorAll('[data-mobile-menu-close]');
    var mobileToggles = header.querySelectorAll('[data-mobile-toggle]');
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');

    var megaCloseTimer = null;
    var activeMegaTrigger = null;

    // ---------- MEGA MENU ----------
    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    function openMegaMenu() {
      if (!megaMenu) return;
      window.clearTimeout(megaCloseTimer);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      header.classList.add('is-mega-open');
      relayoutTraits();
    }

    function closeMegaMenu() {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      header.classList.remove('is-mega-open');
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      activeMegaTrigger = null;
    }

    // Show only the inner panel whose label matches the active trigger.
    function activateMegaInner(label) {
      var matched = false;
      for (var i = 0; i < megaInners.length; i++) {
        var isMatch = megaInners[i].getAttribute('data-mega-menu-label') === label;
        megaInners[i].classList.toggle('is-active', isMatch);
        if (isMatch) {
          megaInners[i].removeAttribute('hidden');
          matched = true;
        } else {
          megaInners[i].setAttribute('hidden', '');
        }
      }
      return matched;
    }

    function openMegaMenuFor(trigger) {
      window.clearTimeout(megaCloseTimer);
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeMegaTrigger = trigger;
      activateMegaInner(trigger.getAttribute('data-mega-menu-label'));
      openMegaMenu();
    }

    // Default the first inner panel to active so there's always a sensible
    // state before any trigger is used.
    if (megaInners.length) {
      megaInners[0].classList.add('is-active');
      megaInners[0].removeAttribute('hidden');
    }

    function scheduleCloseMega() {
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = window.setTimeout(closeMegaMenu, 180);
    }

    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__nav-link-wrapper') || trigger;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        wrapper.addEventListener('pointerenter', function (e) {
          if (!isHoverPointer(e)) return;
          openMegaMenuFor(trigger);
        });
        wrapper.addEventListener('pointerleave', function (e) {
          if (!isHoverPointer(e)) return;
          scheduleCloseMega();
        });
      })(megaTriggers[t]);
    }

    if (megaMenu) {
      megaMenu.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        window.clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMega();
      });
    }

    // ---------- TRAITS BAND MARQUEE (desktop + mobile) ----------
    // Live text curved along a JS-built sine wave, scrolled by sweeping the
    // textPath offset — the same technique as the homepage Key Traits Band. Using
    // real text (not a baked image) means the phrase, incl. "NOOTROPICS", can
    // never be clipped, and it stays editable from the theme editor.
    var traitsMarquees = [];
    var traitsSvgs = header.querySelectorAll('[data-trait-svg]');
    for (var mq = 0; mq < traitsSvgs.length; mq++) {
      var controller = initTraitsTextMarquee(traitsSvgs[mq]);
      if (controller) traitsMarquees.push(controller);
    }

    // The marquees live inside menus that can be hidden (0 width) at init, so
    // re-measure whenever a menu opens. A ResizeObserver also catches viewport
    // changes and the display:none -> shown transition.
    function relayoutTraits() {
      for (var t = 0; t < traitsMarquees.length; t++) traitsMarquees[t].relayout();
    }

    function buildTraitWavePath(width, height) {
      var midY = height / 2;
      var amp = height * 0.26; // peak/trough depth — leaves room for the letters
      var cycles = width < 750 ? 1 : Math.max(2, Math.round(width / 720));
      var step = 8;
      var d = '';
      for (var x = 0; x <= width; x += step) {
        var y = midY + amp * Math.sin((2 * Math.PI * cycles * x) / width);
        d += (d ? ' L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
      }
      var endY = midY + amp * Math.sin(2 * Math.PI * cycles);
      d += ' L' + width.toFixed(1) + ' ' + endY.toFixed(1);
      return d;
    }

    function repeatTraitPhrase(phrase, times) {
      var out = '';
      for (var i = 0; i < times; i++) out += phrase;
      return out;
    }

    function initTraitsTextMarquee(svg) {
      var path = svg.querySelector('[data-trait-path]');
      var textEl = svg.querySelector('[data-trait-text]');
      var textPath = svg.querySelector('[data-trait-textpath]');
      if (!path || !textEl || !textPath) return null;

      var phrase = textEl.getAttribute('data-trait-phrase') || textPath.textContent;
      var duration = (parseFloat(svg.getAttribute('data-trait-speed')) || 30) * 1000; // ms
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      var unitLen = 0; // px advance of one phrase
      var velocity = 0; // px per ms
      var elapsed = 0;
      var last = null;
      var rafId = null;
      var running = false;

      function applyOffset() {
        if (!unitLen) return;
        // Sweep startOffset from -unitLen up to 0 and wrap (moves text left->right);
        // the one-phrase lead-in keeps the whole line covered with no gap.
        var offset = ((elapsed * velocity) % unitLen) - unitLen;
        textPath.setAttribute('startOffset', offset.toFixed(2));
      }

      function layout() {
        var rect = svg.getBoundingClientRect();
        var width = Math.round(rect.width);
        var height = Math.round(rect.height);
        if (!width || !height) return;
        // Pixel-exact viewBox => 1 user unit == 1px, so the font renders crisp.
        svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        path.setAttribute('d', buildTraitWavePath(width, height));
        textPath.textContent = phrase;
        unitLen = textPath.getComputedTextLength();
        if (!unitLen) return;
        var pathLen = path.getTotalLength();
        var repeats = Math.ceil(pathLen / unitLen) + 2;
        textPath.textContent = repeatTraitPhrase(phrase, repeats);
        velocity = unitLen / duration;
        applyOffset();
      }

      function tick(ts) {
        if (last != null) elapsed += ts - last;
        last = ts;
        applyOffset();
        rafId = window.requestAnimationFrame(tick);
      }
      function play() {
        if (running) return;
        running = true;
        last = null;
        rafId = window.requestAnimationFrame(tick);
      }
      function pause() {
        running = false;
        if (rafId) window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      function syncPlayState() {
        if (reducedMotion.matches || document.hidden) pause();
        else play();
      }

      layout();
      syncPlayState();
      // Glyph widths shift once the brand webfont loads, so re-measure then.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(layout);
      }

      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(function () { layout(); });
        ro.observe(svg);
      }
      if (typeof reducedMotion.addEventListener === 'function') {
        reducedMotion.addEventListener('change', syncPlayState);
      }
      document.addEventListener('visibilitychange', syncPlayState);

      return { relayout: layout };
    }

    // ---------- MEGA MENU CATEGORY TABS ----------
    // Each category button switches which product panel is shown.
    var megaTabs = header.querySelectorAll('[data-mega-tab]');
    var megaPanels = header.querySelectorAll('[data-mega-panel]');

    function selectMegaTab(name) {
      for (var i = 0; i < megaTabs.length; i++) {
        var active = megaTabs[i].getAttribute('data-mega-tab') === name;
        megaTabs[i].classList.toggle('is-active', active);
        megaTabs[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      for (var j = 0; j < megaPanels.length; j++) {
        var show = megaPanels[j].getAttribute('data-mega-panel') === name;
        if (show) {
          megaPanels[j].removeAttribute('hidden');
        } else {
          megaPanels[j].setAttribute('hidden', '');
        }
      }
    }

    for (var k = 0; k < megaTabs.length; k++) {
      megaTabs[k].addEventListener('click', function (e) {
        e.preventDefault();
        selectMegaTab(this.getAttribute('data-mega-tab'));
      });
    }

    // ---------- MOBILE MENU ----------
    function openMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('oddit-header-menu-open');
      if (mobileOpenBtn) mobileOpenBtn.setAttribute('aria-expanded', 'true');
      relayoutTraits();
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('oddit-header-menu-open');
      if (mobileOpenBtn) mobileOpenBtn.setAttribute('aria-expanded', 'false');
    }

    if (mobileOpenBtn) {
      mobileOpenBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openMobileMenu();
      });
    }

    for (var c = 0; c < mobileCloseBtns.length; c++) {
      mobileCloseBtns[c].addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileMenu();
      });
    }

    // Expandable mobile sections
    for (var m = 0; m < mobileToggles.length; m++) {
      (function (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var expandable = toggle.closest('.oddit-header__mobile-expandable');
          if (!expandable) return;
          var willOpen = !expandable.classList.contains('oddit-header__mobile-expandable--open');

          // Accordion: only one primary-level link open at a time. Primary
          // expandables are direct children of the primary-links container.
          var parent = expandable.parentElement;
          var isPrimary = parent && parent.classList.contains('oddit-header__mobile-primary-links');
          if (willOpen && isPrimary) {
            for (var s = 0; s < parent.children.length; s++) {
              var sib = parent.children[s];
              if (sib === expandable || !sib.classList) continue;
              if (!sib.classList.contains('oddit-header__mobile-expandable--open')) continue;
              sib.classList.remove('oddit-header__mobile-expandable--open');
              var sibToggle = sib.querySelector(':scope > [data-mobile-toggle]');
              if (sibToggle) sibToggle.setAttribute('aria-expanded', 'false');
            }
          }

          expandable.classList.toggle('oddit-header__mobile-expandable--open', willOpen);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      })(mobileToggles[m]);
    }

    // ---------- CART TOGGLE ----------
    for (var ct = 0; ct < cartToggles.length; ct++) {
      cartToggles[ct].addEventListener('click', function (e) {
        e.preventDefault();
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      });
    }

    var anchorReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var userHasScrolled = false;

    function markUserScrolled() {
      userHasScrolled = true;
    }

    window.addEventListener('wheel', markUserScrolled, { passive: true, once: true });
    window.addEventListener('touchstart', markUserScrolled, { passive: true, once: true });
    window.addEventListener('keydown', markUserScrolled, { once: true });

    function headerBarHeight() {
      var bar = header.querySelector('.oddit-header__bar');
      return (bar || header).offsetHeight || 0;
    }

    function scrollToAnchor(target, instant) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerBarHeight();
      if (top < 0) top = 0;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: top,
          behavior: instant || anchorReducedMotion.matches ? 'auto' : 'smooth'
        });
      } else {
        window.scrollTo(0, top);
      }
    }

    function resolveLinkUrl(link) {
      var resolver = document.createElement('a');
      resolver.href = link.getAttribute('href') || '';
      return resolver;
    }

    function sameDocumentAnchorTarget(link) {
      var url = resolveLinkUrl(link);
      if (!url.hash || url.hash.length < 2) return null;
      if (url.hostname && url.hostname !== window.location.hostname) return null;
      var path = url.pathname.charAt(0) === '/' ? url.pathname : '/' + url.pathname;
      if (path !== window.location.pathname) return null;
      return document.getElementById(url.hash.slice(1));
    }

    header.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest('a[href*="#"]');
      if (!link || !header.contains(link)) return;
      if (link.hasAttribute('data-mega-menu-trigger')) return;
      var target = sameDocumentAnchorTarget(link);
      if (!target) return;
      e.preventDefault();
      closeMobileMenu();
      closeMegaMenu();
      scrollToAnchor(target, false);
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', resolveLinkUrl(link).hash);
      }
    });

    function alignToInitialHash() {
      if (userHasScrolled) return;
      if (window.location.hash.length < 2) return;
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) scrollToAnchor(target, true);
    }

    alignToInitialHash();
    window.addEventListener('load', alignToInitialHash);

    // ---------- KEYBOARD: ESC to close menus ----------
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else if (megaMenu && megaMenu.classList.contains('is-open')) {
        closeMegaMenu();
      }
    });

    // ---------- CLOSE MEGA MENU ON OUTSIDE CLICK ----------
    document.addEventListener('click', function (e) {
      if (!megaMenu || !megaMenu.classList.contains('is-open')) return;
      if (megaMenu.contains(e.target)) return;
      var insideTrigger = false;
      for (var i = 0; i < megaTriggers.length; i++) {
        if (megaTriggers[i].contains(e.target)) { insideTrigger = true; break; }
      }
      if (!insideTrigger) closeMegaMenu();
    });

    // ---------- TRANSPARENT HEADER OVER HERO (homepage) ----------
    // The header starts transparent and overlays the hero. Once the hero
    // scrolls up behind the bar we add `is-scrolled` so the solid background
    // returns and nav stays legible over the light sections below.
    if (header.hasAttribute('data-transparent-on-hero')) {
      var hero = document.querySelector('.oddit-section-hero');
      var bar = header.querySelector('.oddit-header__bar');
      var headerHeight = (bar || header).offsetHeight || 70;
      if (hero && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 }).observe(hero);
      } else if (hero) {
        var onScroll = function () {
          header.classList.toggle('is-scrolled', window.pageYOffset > hero.offsetHeight - headerHeight);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }
  }

  // ---------- LIVE CART COUNT BADGE ----------
  document.addEventListener('cart:updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var count = e.detail.cart.item_count || 0;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      // Only the header's floating badge bubble should hide at zero. Other
      // counters (e.g. the cart drawer title "Cart (0)") must keep showing 0.
      if (badges[i].classList.contains('oddit-header__cart-count')) {
        badges[i].style.display = count > 0 ? '' : 'none';
      }
    }
  });

  // ---------- INIT ----------
  function init() {
    var headers = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < headers.length; i++) {
      initHeader(headers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target.querySelector(SECTION_SELECTOR);
    if (header) initHeader(header);
  });
})();
